//请自行添加语言资源
const soldCreate = {
  totalBoxQty: '总箱数',
  totalPrice: '客户未税总金额',
  totalPriceTax: '客户含税总金额',
  peerNumber:'同行单号',
  createDate: '创建日期',
  orderValidDate: '订单有效期',
  customerOrderNo: '采购订单号',
  productNo: '产品编号',
  shiptoNo: '客户代码(ship to)',
  district: '详细地址',
  materielNo: '物料号',
  productName: '产品名称',
  otsCustomerProductNo: '客户端产品代码',
  containerSize: '箱容',
  packageQty: '包数',
  orderBoxQty: '箱数(CS)',
  customerPriceNoTax: '客户未税单箱价',
  customerPrice: '客户含税单箱价',
  materielTypeNo: '物料类型',
  categoryName: '品类',

  referencePriceNoTax: '参考未税单箱价',
  referencePrice: '参考含税单箱价',

  pickUpFlag: '自提',
  fullGoodsFlag: '货齐发货',
  outStockNotCloseFlag: '缺货不关单',
  peerOrderFlag: '同行订单',
  remark: '备注',
  soldtoName: '售达名称',
  lineNumber: '行号',
  preferenceFlag: '偏好',
  grossWeight: '毛重',
  netWeight: '净重',
  volume: '体积',
  whQty: '库存数量',
  whNo: '仓库编码',
  whCity: '仓库城市',
  msg: {
    telephone: '请填写电话',
    peerNumber: '请输入需同行308单号或POP号',
    pickUpFlag: '自提，请同步准备自提委托书并联系相应发货 DC;',
    peerOrderFlag: '同行订单，需添加同行308单号或POP号',
    placeholder: '请选择'
  },
  totalWeight: '总重量',
  totalVolume: '总体积'
};
export default soldCreate



// WEBPACK FOOTER //
// ./src/page/order/soldCreate/lang/soldCreate.zh.js